import script from "./PreSportCouponsCompetitionsOld.vue?vue&type=script&setup=true&lang=js"
export * from "./PreSportCouponsCompetitionsOld.vue?vue&type=script&setup=true&lang=js"

import "./PreSportCouponsCompetitionsOld.vue?vue&type=style&index=0&id=7ea7ae66&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7ea7ae66"]])

export default __exports__